import { createContext } from 'react'

import defaultProperties from './defaultProperties'

const SettingsContext = createContext( { ...defaultProperties });

export default SettingsContext ;